import { render, staticRenderFns } from "./StreakCalendar.vue?vue&type=template&id=20a57670&scoped=true&"
import script from "./StreakCalendar.vue?vue&type=script&lang=ts&"
export * from "./StreakCalendar.vue?vue&type=script&lang=ts&"
import style0 from "./StreakCalendar.vue?vue&type=style&index=0&id=20a57670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a57670",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('20a57670', component.options)
    } else {
      api.reload('20a57670', component.options)
    }
    module.hot.accept("./StreakCalendar.vue?vue&type=template&id=20a57670&scoped=true&", function () {
      api.rerender('20a57670', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/userhome/components/StreakCalendar.vue"
export default component.exports